import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { loadStatement } from '../../../redux-flow/actions/wallet_transactions'
import { Link } from 'react-router-dom'
import Navbar from '../../../Components/Navbar'
// import Footer from '../../../Components/Footer'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../wallet.css'
import WalletSaldo from '../../../Components/WalletSaldo'
import BreadCrumb from '../../../Components/BreadCrumb'
import InsideMenu from '../../../Components/InsideMenu'
import moment from 'moment'
import { Icon, List, Skeleton, Empty } from 'antd'
// import LoginWallet from '../loginWallet'
import { login } from '../../../redux-flow/actions/wallet'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import SideBar from '../../../Components/SideBar'

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class ExtratoWallet extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            password: '',
            loading: false,
            conversoes: this.props.statement,
            filter: 0,
            currentPage: 1, 
            req: false
        }
    }
    
    componentDidMount() {
        const { onLoad, userid, onLogged, walletLogged } = this.props
        if(onLoad && userid) {
            onLoad(userid)
        }
        if(walletLogged) {
            onLogged(userid)
        }
    }

    componentDidUpdate(){
        this.setState((state) => {
            console.log(state)
            return state
        })
    }

    handleFilter = (e) => {
        this.setState({
            filter: e
        })
        let aux = this.props.statement
        let helper
        if(e === 1) {
            helper = aux.filter(transacoes => transacoes.tipo === 1)
        } else if(e === 2) {
            helper = aux.filter(transacoes => transacoes.tipo === 2)
        } else if(e === 3) {
            helper = aux.filter(transacoes => transacoes.tipo === 3)
        } else if(e === 4) {
            helper = aux.filter(transacoes => transacoes.tipo === 4)
        } else if(e === 5) {
            helper = aux.filter(transacoes => transacoes.tipo === 5)
        } else if (e === 6) {
            helper = aux.filter(transacoes => transacoes.tipo === 6)
        } else if (e === 7) {
            helper = aux.filter(transacoes => transacoes.tipo === 7)
        } else {
            helper = aux
        }

        this.setState({
            conversoes: helper
        })
    }

    handleChange = (e) => {
        this.setState({
            password: e.target.value
        })
    }

    returnType = (type) => {
        if(type === 1){
            return 'Envio de RIB'
        } else if(type === 2){
            return 'RIB > R$'
        } else if(type === 3) {
            return 'R$ > RIB'
        } else if(type === 4) {
            return 'Crédito R$'
        } else if(type === 5) {
            return 'Transferência R$'
        } else if(type === 7) {
            return 'Dividendos'
        } else {
            return 'Crédito RIB'
        }
    }

    returnStatusClass = (status) => {
        if(status === true || status === 3 || status === 'CONFIRMED') {
            return 'statusConfirmed'
        } else if(status === false){
            return 'statusToBe'
        } else {
            return 'statusFailed'
        }
    }

    returnStatusName = (status) => {
        if(status === true || status === 3 || status === 'CONFIRMED') {
            return 'Confirmado'
        } else if(status === false){
            return 'Pendente'
        } else {
            return 'Inválido'
        }
    }

    returnDate = (i, date) => {
        
        if (i+((this.state.currentPage - 1)*10) === 0) {
            return (<h6 className="transactionDate distanciaData">{moment(date).format("DD/MM/YYYY")}</h6>)
        } else {
            if(this.state.conversoes.length > 0) {
                if(moment(this.state.conversoes[(i+((this.state.currentPage - 1)*10))-1].date).format("DD/MM/YYYY") != moment(date).format("DD/MM/YYYY")) {
                    return (<h6 className="transactionDate distanciaData">{moment(date).format("DD/MM/YYYY")}</h6>)
                } else {
                    if(i%10 === 0) {
                        return (<h6 className="transactionDate distanciaData">{moment(date).format("DD/MM/YYYY")}</h6>)
                    } else {
                        return ''
                    }
                }
            } else {
                if(moment(this.props.statement[(i+((this.state.currentPage - 1)*10))-1].date).format("DD/MM/YYYY") != moment(date).format("DD/MM/YYYY")) {
                    return (<h6 className="transactionDate distanciaData">{moment(date).format("DD/MM/YYYY")}</h6>)
                } else {
                    if(i%10 === 0) {
                        return (<h6 className="transactionDate distanciaData">{moment(date).format("DD/MM/YYYY")}</h6>)
                    } else {
                        return ''
                    }
                }
            }
        }
    }
        
    render() {

            const { logged, userLogged, isLoading, statement, userExpiration, success, loginExpired, walletLogged } = this.props
            return (
    
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> : (
                        userLogged.permissao === 0 || userLogged.permissao === 2 || userLogged.permissao === 4 ? <Redirect to="/minhaconta" /> :
                        <div>
                            <Container>
                                    <div className="section minhaContaWrapper">
                                        <Row>
                                            <Col md={12} className="p-0">
                                                <InsideMenu /> 
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="section insideSec">
                                        <Row>
                                            <Col md={2} className="p-0" style={{borderRight: '1px solid #F6F3FF'}}>
                                                <SideBar permissao={userLogged.permissao} nivelVerificacao={userLogged.nivelVerificacao} />
                                            </Col>
                                            <Col md={10}>
                                            <div>

                                                <WalletSaldo/>

                                                <BreadCrumb page="Extrato" link="/wallet/extrato" />

                                                <Row className="section">
                                                    <Col md={12} className="divMobile flex-wrap">
                                                        <label className="extratoNome">Extrato</label>
                                                        <label className="filterName pb-0 mb-0">Filtros</label>
                                                        <div className="d-flex mt-2 scrollFiltro">
                                                            <label className={`btn walletFilter ${this.state.filter === 1 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(1)}>Transferências RIB</label>
                                                            <label className={`btn walletFilter ml-3 ${this.state.filter === 6 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(6)}>Crédito  RIB</label>
                                                            <label className={`btn walletFilter ml-3 mr-3 ${this.state.filter === 3 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(3)}>Conversão R$ → RIB</label>
                                                            <label className={`btn walletFilter ${this.state.filter === 2 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(2)}>Conversão RIB → R$</label>
                                                            <label className={`btn walletFilter ml-3 mr-3 ${this.state.filter === 4 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(4)}>Crédito R$</label>
                                                            <label className={`btn walletFilter ${this.state.filter === 5 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(5)}>Transferências R$</label>
                                                            <label className={`btn walletFilter ${this.state.filter === 7 ? 'walletFilterActive' : ''}`} onClick={() => this.handleFilter(7)}>Dividendos</label>
                                                            {this.state.filter != 0 ?
                                                            <label className={`btn walletFilter ml-3`} onClick={() => this.handleFilter(0)}>Ver todos</label> : '' }
                                                        </div>
                                                    </Col>
                                                    <Col md={12} className="marginNegativa">
                                                            {isLoading ? <div><Skeleton active className="marginPositiva pl-4"/><Skeleton active className="pl-4" /></div> :
                                                            <List 
                                                                dataSource={this.state.filter === 0 ? statement : this.state.conversoes}
                                                                pagination={{
                                                                    pageSize: 10,
                                                                    onChange: (i) => this.setState({ currentPage: i })
                                                                }}
                                                                locale={{ emptyText: <Empty description="Nenhuma transação encontrada" /> }}
                                                                renderItem={(item, i) => (
                                                                    <Row className={`pl-3 col-mobile ${i === 0 ? 'mt-5' : 'mt-3'}`}>
                                                                        <Col md={4}>
                                                                            {this.returnDate(i, item.date)}
                                                                        </Col>

                                                                        <Col md={8} className="d-flex justify-content-between col-mobile">
                                                                            <h6 className="transactionType transactionHour dateMobile">{moment(item.date).format("HH:mm")}</h6>
                                                                            <Link className="transactionLink" to={`/wallet/transacao?id=${item.transactionId}&type=${item.tipo}&status=${item.status}`}><div className="d-flex justify-content-between align-items-center transaction pb-4">
                                                                                <h6 className="transactionType dateTypeMobile">{this.returnType(item.tipo)}<br />{moment(item.date).format("HH:mm")}</h6>
                                                                                <h6 className="transactionType dateTypeDesktop">{this.returnType(item.tipo)}</h6>
                                                                                <h6 className="transactionAmount">{item.tipo != 4 && item.tipo != 5 && item.tipo != 7 ? Number(item.valor).toFixed(8)+' RIB' : 'R$ '+(item.valor).toFixed(2).replace('.',',')}</h6>
                                                                                <h6 className={`transactionStatus ${this.returnStatusClass(item.status)}`}>{this.returnStatusName(item.status)}</h6>
                                                                            </div></Link>
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                            />
                                                            }
                                                    </Col>
                                                </Row>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                        </div>
                        
                    )}
                    {/* <Footer /> */}
                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
    userid: state.login.userid,
    isLoading: state.wallet_transactions.isLoading,
    statement: state.wallet_transactions.statement,
    success: state.wallet_transactions.success,
    userExpiration: state.wallet.userExpiration,
    loginExpired: state.wallet.loginExpired,
    walletLogged: state.wallet.walletLogged
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    },
    onLogged: id => {
        dispatch(loadStatement(id))
    },
    handleSubmit: (pass, email, userid) => {
        dispatch(login(pass, email, userid))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(ExtratoWallet)